import React, { useEffect } from "react";
import {
  Grid,
  DialogContent,
  DialogActions,
  Button,
  makeStyles,
  Theme,
  createStyles,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../core/redux/ducks/user";
import { useFormik } from "formik";
import * as Yup from "yup";
import { PasswordField } from "../../components/PasswordField";

interface IChangePasswordProps {
  closeModal(): void;
}

const validationSchema = Yup.object().shape({
  oldPassword: Yup.string().max(50, "Too Long!").required("Required"),
  newPassword: Yup.string()
    .min(8, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
});

export const ChangePassword: React.FC<IChangePasswordProps> = ({
  closeModal,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const status = useSelector((state) => state.user.status);
  const changePassword = (oldPw: string, newPw: string) =>
    Actions.changePassword(dispatch, oldPw, newPw);
  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
    },
    onSubmit: (values) => {
      changePassword(values.oldPassword, values.newPassword);
    },
    validationSchema,
  });

  useEffect(() => {
    if (status === "password-saved") closeModal();
  }, [status]);
  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <DialogContent>
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid item md={12}>
              <PasswordField
                id="oldPassword"
                value={formik.values.oldPassword}
                onChange={formik.handleChange}
                autoFocus
                fullWidth
                label="Old password"
                error={!!formik.errors.oldPassword}
                className={classes.pwField}
              />
            </Grid>
            <Grid item md={12}>
              <PasswordField
                id="newPassword"
                label="New password"
                value={formik.values.newPassword}
                onChange={formik.handleChange}
                type="password"
                fullWidth
                helperText={formik.errors.newPassword}
                error={!!formik.errors.newPassword}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={closeModal}>
            Abbruch
          </Button>
          <Button color="primary" type="submit">
            Update
          </Button>
        </DialogActions>
      </form>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pwField: {
      margin: "20px 0",
    },
  })
);
